import classNames from 'classnames';
import PropTypes from 'prop-types';
import formatCurrency, { formatCurrencyCompact } from '../../../../utils/formatCurrency';
import { PendingStatChip } from './PendingListStatusBadge';

/**
 * 待办统计：Chip 金额 + 独立条图（金额构成/笔数，非互斥占比）。
 * @param {{ key: string, label: string, amount: number, count: number, active?: boolean }[]} items
 */
const PendingListStatsPanel = ({ items = [], onSelect, showChart = true, className }) => {
	const visible = (Array.isArray(items) ? items : []).filter((item) => Number(item?.amount) > 0);
	if (visible.length === 0) return null;

	const maxAmount = Math.max(...visible.map((item) => Number(item.amount) || 0), 1);
	const interactive = typeof onSelect === 'function';

	return (
		<div className={classNames('pending-list-stats-panel', className)}>
			<div className='pending-list-stats-panel__chips'>
				{visible.map((item) => (
					<PendingStatChip
						key={item.key}
						label={item.label}
						value={formatCurrencyCompact(item.amount)}
						title={formatCurrency(item.amount)}
						active={item.active !== false}
						onClick={interactive ? () => onSelect(item.key) : undefined}
					/>
				))}
			</div>
			{showChart ? (
				<div className='pending-list-stats-panel__chart' role='list' aria-label='统计构成'>
					{visible.map((item) => {
						const amount = Number(item.amount) || 0;
						const widthPct = Math.max(6, Math.round((amount / maxAmount) * 100));
						const isActive = item.active !== false;
						const canClick = interactive && typeof onSelect === 'function';
						return (
							<div
								key={`bar-${item.key}`}
								role={canClick ? 'button' : 'listitem'}
								tabIndex={canClick ? 0 : undefined}
								title={`${item.label} ${formatCurrency(amount)} · ${Number(item.count) || 0} 笔`}
								className={classNames('pending-list-stats-bar', {
									'pending-list-stats-bar--active': isActive,
									'pending-list-stats-bar--inactive': !isActive,
									'pending-list-stats-bar--interactive': canClick,
								})}
								onClick={canClick ? () => onSelect(item.key) : undefined}
								onKeyDown={
									canClick
										? (event) => {
												if (event.key === 'Enter' || event.key === ' ') {
													event.preventDefault();
													onSelect(item.key);
												}
											}
										: undefined
								}
							>
								<div className='pending-list-stats-bar__meta'>
									<span className='pending-list-stats-bar__label'>{item.label}</span>
									<span className='pending-list-stats-bar__count'>
										{formatCurrencyCompact(amount)} · {Number(item.count) || 0}笔
									</span>
								</div>
								<div className='pending-list-stats-bar__track' aria-hidden>
									<span className='pending-list-stats-bar__fill' style={{ width: `${widthPct}%` }} />
								</div>
							</div>
						);
					})}
				</div>
			) : null}
		</div>
	);
};

PendingListStatsPanel.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			amount: PropTypes.number.isRequired,
			count: PropTypes.number,
			active: PropTypes.bool,
		}),
	),
	onSelect: PropTypes.func,
	showChart: PropTypes.bool,
	className: PropTypes.string,
};

export default PendingListStatsPanel;
